import { Component } from "@angular/core";
import { LINK_PAGES } from "src/constants/param-constants";

@Component({
  standalone: true,
  selector: "app-ccpa",
  template: ""
})
export class CcpaComponent {
  constructor() {
    // We won't render the GDPR page, so redirecting to the legal site
    window.open(`${LINK_PAGES.CA_PRIVACY_NOTICE}`, '_top');
  }
}
